export enum PAYMENT_METHOD {
  QR = 'QR',
  BANK = 'BANK',
  CREDIT = 'CREDIT',
}
export enum LanguageCode {
  VI = 'vi',
  EN = 'en',
  ZH = 'zh',
  KO = 'ko',
  RU = 'ru',
}
export enum STATUS {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}

export const LANGUAGES = [
  LanguageCode.VI,
  LanguageCode.EN,
  LanguageCode.ZH,
  LanguageCode.KO,
  LanguageCode.RU,
] as const
export const DEFAULT_LANGUAGE = LanguageCode.VI

// Blur placeholder
export const blurDataURL =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjQwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNlZWUiLz48L3N2Zz4='
